<template>
  <button class="button" :class="classes" @click="handleClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  computed: {
    classes() {
      return {
        'button--accent': this.color === 'accent',
        'button--primary': this.color === 'primary',
        'button--text': this.text,
      }
    },
  },
  props: {
    color: {
      type: String,
      default: '',
    },
    text: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick(event) {
      if (this.to && this.to !== this.$route.fullPath)
        this.$router.push(this.to)
      else this.$emit('click', event)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.button {
  background: $colorPrimary;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  padding: 1rem;
  text-transform: uppercase;
  transition: 200ms;

  &:hover {
    background: $colorPrimaryLight;
  }

  &--accent {
    background: $colorAccent;
    color: $colorBackground;

    &:hover {
      background: $colorAccentDark;
    }
  }

  &--text {
    background: $colorBackground;
    font-weight: 700;
  }
}
</style>
